/** Member queries — member lists, single member, contact cadences, step recipients, activity. */

import { CADENCE_MEMBER_FIELDS } from './fragments';

export const CADENCE_MEMBERS_QUERY = `
  query CadenceMembers($cadenceId: ID!, $filter: CadenceMemberFilterInput) {
    cadenceMembers(cadenceId: $cadenceId, filter: $filter) {
      edges {
        cursor
        node {
          ${CADENCE_MEMBER_FIELDS}
        }
      }
      totalCount
    }
  }
`;

export const CADENCE_MEMBER_QUERY = `
  query CadenceMember($id: ID!) {
    cadenceMember(id: $id) {
      id
      contactId
      email
      status
      enrolledAt
      currentEventId
      nextEventScheduledAt
      isSuccessful
      successAchievedAt
      removedAt
      removedByUserId
      removalReason
      removalDetails
      completedAt
      totalEmailsSent
      totalEmailsDelivered
      totalEmailsOpened
      totalEmailsClicked
      totalEmailsReplied
      totalEmailsBounced
      totalEventsReceived
      totalInteractions
      displayStatus
      statusExplanation
      derivedDelivered
      emailsAttempted
      createdAt
      failureEvents {
        id
        failureType
        failureReason
        failureDetails
        triggeredAt
        cadenceEventId
      }
    }
  }
`;

export const CONTACT_CADENCES_QUERY = `
  query ContactCadences($contactId: ID!) {
    contactCadences(contactId: $contactId) {
      cadenceId
      cadenceName
      cadenceMemberId
      cadenceType
      cadenceStatus
      status
      enrolledAt
      completedAt
      removedAt
      removedByUserId
      removalReason
      removalDetails
      isSuccessful
      successAchievedAt
      goalDescription
      currentEventId
      nextActionName
      nextActionDate
      totalEmailsSent
      totalEmailsOpened
      displayStatus
      statusExplanation
      canManage
      activities {
        activityType
        activityAt
      }
    }
  }
`;

export const STEP_RECIPIENTS_QUERY = `
  query StepRecipients($cadenceId: ID!, $cadenceEventId: ID!, $deliveryStatusFilter: [StepDeliveryStatus!], $pagination: CadencePaginationInput, $sendAfter: datetime, $sendBefore: datetime) {
    stepRecipients(cadenceId: $cadenceId, cadenceEventId: $cadenceEventId, deliveryStatusFilter: $deliveryStatusFilter, pagination: $pagination, sendAfter: $sendAfter, sendBefore: $sendBefore) {
      edges {
        cursor
        node {
          cadenceMemberId
          contactId
          name
          email
          phone
          selectedStep
          currentStatus
          deliveryStatus
          activityAt
          sendAt
          derivedDelivered
          emailDelivered
          emailOpened
          emailClicked
          emailReplied
          emailBounced
          emailUnsubscribed
          taskCompleted
          taskSkipped
          isSuccessful
          exitedAtThisStep
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const RECENT_CADENCE_ACTIVITY_QUERY = `
  query RecentCadenceActivity($cadenceId: ID!) {
    recentCadenceActivity(cadenceId: $cadenceId) {
      edges {
        node {
          id
          cadenceId
          cadenceMemberId
          contactId
          cadenceEventId
          activityType
          activityAt
          details
          emailSendId
          memberIterationCount
          cadenceIterationCount
        }
      }
    }
  }
`;

export const CADENCE_MEMBER_ACTIVITY_QUERY = `
  query CadenceMemberActivity($cadenceMemberId: ID!) {
    cadenceMemberActivity(cadenceMemberId: $cadenceMemberId) {
      edges {
        node {
          id
          cadenceId
          cadenceMemberId
          contactId
          cadenceEventId
          activityType
          activityAt
          details
          recipientEmail
          emailSendId
          memberIterationCount
          cadenceIterationCount
        }
      }
    }
  }
`;
